import { either } from "fp-ts";

import { UserRoleEntity } from "~/entities/user-role";
import { createConfig } from "~/shared/config";

function buildConfigFromEnv() {
  const eitherConfig = createConfig(
    {
      ...import.meta.env,
      ...(import.meta.env.DEV && { NODE_ENV: "dev" }),
      ...(import.meta.env.PROD && { NODE_ENV: "prod" }),
    },
    [UserRoleEntity.zFlatRoleByRoleId.keySchema, UserRoleEntity.zFlatRoleByRoleId.valueSchema],
  );

  if (either.isLeft(eitherConfig)) throw eitherConfig.left;

  return eitherConfig.right;
}

export { buildConfigFromEnv };
